import React from 'react'
import {Row, Col} from 'antd'
import PropTypes from 'prop-types'
//Model

// Components
import ViewTable from '../../../Table/ViewTable'
import Button from '../../../Buttons'
import RowTools from "../../../Table/RowTools";
import helper from "../../../../helper/helper";
import MDSDModal from "../Modal";

// Columns
const columns_form = (showEditModal, deleteRowModal) => [
  {
    title: "#",
    dataIndex: "stt",
    width: "65px",
  },
  {
    title: "Ký hiệu",
    dataIndex: "kyHieu",
    width: "25%"
  },
  {
    title: "Tên mục đích",
    dataIndex: "ten",
  },
  {
    title: "Thao tác",
    render: (value, row) => (
      <RowTools row={row} deleteRowModal={() => deleteRowModal(row)} showEditModal={showEditModal}/>
    ),
    width: "70px"
  },
];
export default class MDSD extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      isAddModalOpen: false,
      isEditModalOpen: false,
      miningQuantity: [],
      selectedRow: null
    }
  }

  handleOpenAddModal = () => {
    this.setState({
      isAddModalOpen: true
    })
  };

  handleOpenEditModal = (row) => {
    this.setState({
      selectedRow: row,
      isEditModalOpen: true
    })
  };

  handleShowDetail = (row) => {
    this.setState({
      selectedRow: row,
    })
  };

  handleCloseModal = () => {
    this.setState({
      isAddModalOpen: false,
      isEditModalOpen: false,
      selectedRow: null
    })
  };

  handleAdd = (item) => {
    const {dataSource, handleUpdate} = this.props;
    const newData = [{...item,  daXoa: 0}, ...dataSource];
    this.handleCloseModal();
    handleUpdate(newData);
  };

  handleEdit = (item) => {
    const {dataSource, handleUpdate, field} = this.props;
    const newData = helper.replaceItem(item, dataSource, "stt");
    this.handleCloseModal();
    handleUpdate(newData, field);
  };

  handleDelete = (item) => {
    const {dataSource, handleUpdate, field, isEdit} = this.props;
    const newData = helper.updateArray(item,dataSource,isEdit)
    handleUpdate(newData, field); 
  };

  addSttToItems = (items) => {
    if (!items) return [];
    let newItems = [];
    if (items) {
      newItems = items.filter(item => item.daXoa === 0)
    }
    return newItems;
  };

  render() {
    const {isAddModalOpen, isEditModalOpen, selectedRow} = this.state;
    const {dataSource, mode} = this.props;
    return (
      <Row>
        <Row type="flex" justify="end" align="middle">
          {mode !== "presentation" &&
          <Button type="primary" onClick={this.handleOpenAddModal} icon="plus"/>}
        </Row>
        <div className="mt-10"/>
        <div style={{  maxHeight: "350px", overflowY: "auto"}}>
          <ViewTable
            bordered pagination={false}
            columns={columns_form(this.handleOpenEditModal, this.handleDelete)}
            dataSource={this.addSttToItems(dataSource)}
          />
        </div>

        {isAddModalOpen &&
        <MDSDModal
          mode="form"
          isOpen={isAddModalOpen}
          handleCancel={this.handleCloseModal}
          handleOk={this.handleAdd}/>}

        {isEditModalOpen &&
        <MDSDModal
          mode="form"
          initialValues={selectedRow}
          isOpen={isEditModalOpen}
          handleCancel={this.handleCloseModal}
          handleOk={this.handleEdit}
          isEdit={true}
          />}
      </Row>
    )
  }
}

MDSD.propTypes = {
  // MODE: string "form" and "presentation"
  mode: PropTypes.string.isRequired,
  dataSource: PropTypes.array.isRequired,
  handleUpdate: PropTypes.func,
};